var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentageOff = function SvgPercentageOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 112,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59.013 33.073-11.49-7.71a18.189 18.189 0 0 0-23.493 2.772l-9.655 10.499a9.177 9.177 0 0 0-2.368 7.342l7.195 57.706a5.508 5.508 0 0 0 6.15 4.791l40.067-5.048a5.508 5.508 0 0 0 4.79-6.13l-7.213-57.78a9.177 9.177 0 0 0-3.983-6.442Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m70.234 97.27-7.207-57.732a9.17 9.17 0 0 0-3.98-6.474l-11.48-7.703a18.175 18.175 0 0 0-23.475 2.77l-9.17 9.94a45.39 45.39 0 0 1 27.18 68.241l23.345-2.953a5.502 5.502 0 0 0 4.787-6.088Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.311 22.283a17.313 17.313 0 0 0-12.729 5.683L14.62 38.78a8.012 8.012 0 0 0-2.065 6.46l7.407 59.553a4.3 4.3 0 0 0 4.773 3.693l41.35-5.152a4.218 4.218 0 0 0 2.822-1.61 4.163 4.163 0 0 0 .872-3.144l-7.426-59.63a8.07 8.07 0 0 0-3.504-5.682l-11.857-7.955a17.407 17.407 0 0 0-9.736-3.03h.056Z",
    stroke: "#30384C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m69.828 14.763-13.234-4.24a18.172 18.172 0 0 0-21.825 9.178L28.381 32.44a9.178 9.178 0 0 0-.238 7.727l22.944 53.451a5.508 5.508 0 0 0 7.232 2.9l37.133-15.84a5.507 5.507 0 0 0 2.9-7.232L75.464 19.903a9.178 9.178 0 0 0-5.635-5.14Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.54 73.278 75.756 19.852a9.158 9.158 0 0 0-5.623-5.129l-13.206-4.23a18.133 18.133 0 0 0-10.348-.22 56.34 56.34 0 0 1 27.876 79.233l21.118-9.011a5.494 5.494 0 0 0 2.968-7.217Z",
    fill: "#EAEAEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.703 9.65a17.256 17.256 0 0 0-15.438 9.584l-6.591 13.145a8.05 8.05 0 0 0-.209 6.763L52.01 94.357a4.262 4.262 0 0 0 5.683 2.235L96.03 80.245a4.262 4.262 0 0 0 2.235-5.588L74.551 19.404a8.05 8.05 0 0 0-4.944-4.508L56.026 10.52a17.728 17.728 0 0 0-5.323-.87Z",
    stroke: "#30384C",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.514 36.944a9.737 9.737 0 0 1-3.789-.72 9.945 9.945 0 1 1 3.713.72h.076Z",
    stroke: "#30384C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.48 41.998 57.484 86.027",
    stroke: "#30384C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.072 56.435a5.682 5.682 0 1 1-10.514 4.314 5.682 5.682 0 0 1 10.514-4.314ZM85.196 67.346a5.682 5.682 0 1 1-10.514 4.314 5.682 5.682 0 0 1 10.514-4.314Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.926 75.76h-.002a6.179 6.179 0 1 1 2.413-.506l-.002.001c-.76.33-1.58.502-2.409.505ZM52.83 64.77h-.001a6.179 6.179 0 1 1 2.413-.504h-.002c-.76.33-1.58.502-2.41.505Z",
    stroke: "#30384C",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m21.144 49.55 3.914 29.794M25.874 83.938l1.25 9.488M48.068 17.473c-5.897 6.664 8.21 19.59 19.944-1.41 10.48-18.756-9.134-14.54-13.127-6.738",
    stroke: "#30384C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgPercentageOff;